var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggler"},[_c('button',{staticClass:"btn",class:_vm.buttonClass,attrs:{"title":_vm.title,"aria-label":_vm.title},on:{"click":_vm.cycleTheme}},[_c('i',{staticClass:"sr",class:_vm.iconClass})])])
}
var staticRenderFns = []

export { render, staticRenderFns }